import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Admin from "./Layouts/Admin/Admin";
import Auth from "./Layouts/Auth/Auth";
import User from "./Layouts/User/User";

import NewUser from "./Layouts/NewUser/NewUser";
import PreOnboardingDetails from "./Pages/NewUserPages/PreOnboardingDetails";
import Report from "./Pages/AdminPages/GeoTag/Report/Report";
import Profile from "./Pages/CommonPages/Profile/Profile";
import CompanyPolicies from "./Pages/CommonPages/CompanyPolicies/CompanyPolicies";
import Ticket from "./Pages/UserPages/Ticket/Ticket";
import ManageTickets from "./Pages/AdminPages/ManageTickets/ManageTickets";
import EmployeesManager from "./Pages/AdminPages/EmployeesManager/EmployeesManager";
import Login from "./Pages/LoginPages/Login";
import EmployeeAllDetails from "./Pages/AdminPages/EmployeesManager/EmployeeAllDetails";
import ComingSoon from "./Pages/CommonPages/NotFound/ComingSoon";
import Documentation from "./Pages/AdminPages/GeoTag/Documentation/Documentation";
import IdCard from "./Pages/AdminPages/EmployeesManager/IdCard";
import Mediclaim from "./Pages/UserPages/Mediclaim/Mediclaim";
import Employee from "./Pages/UserPages/Employee/Employee";
import EmployeeAdmin from "./Pages/AdminPages/GeoTag/Employees/Employee";
import Notification from "./Pages/AdminPages/Notification/Notification";
import MediclaimHr from "./Pages/AdminPages/EmployeesManager/MediclaimHr";
import AddEmployee from "./Pages/AdminPages/EmployeesManager/AddEmployee";
import IdentityDetail from "./Pages/NewUserPages/Forms/IdentityDetail";
import PersonalDetails from "./Pages/NewUserPages/Forms/PersonalDetails";
import ContactDetails from "./Pages/NewUserPages/Forms/ContactDetails";
import EmergencyDetails from "./Pages/NewUserPages/Forms/EmergencyDetails";
import WorkProfile from "./Pages/NewUserPages/Forms/WorkProfile";
import BankDetails from "./Pages/NewUserPages/Forms/BankDetails";
import UploadDocuments from "./Pages/NewUserPages/Forms/UploadDocuments";
import Nominee from "./Pages/NewUserPages/Forms/Nominee";
import OfferLetter from "./Pages/NewUserPages/Forms/OfferLetter";
import EmployeeView from "./Pages/AdminPages/EmployeesManager/EmployeeView";
import Dashboard from "./Pages/UserPages/Employee/Dashboard";
import Sop from "./Pages/AdminPages/Sop";
import Attendence from "./Pages/UserPages/Employee/Attendence";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={<Auth />}>
          <Route index element={<Login />} />
        </Route>

        <Route path="/admin" element={<Admin />}>
          <Route
            path="/admin/employees-verification"
            element={<EmployeesManager pageType="employees-verification" />}
          />
          <Route
            path="/admin/employees-manager"
            element={<EmployeesManager pageType="employees-manager" />}
          />

          <Route path="/admin/add-emp" element={<AddEmployee />} />
          <Route
            path="/admin/employees-manager/:id"
            element={<EmployeeAllDetails pageType="employees-manager" />}
          />
          <Route
            path="/admin/employees-verification/edit/:id"
            element={<EmployeeAllDetails pageType="employees-verification" />}
          />
          <Route path="/admin/documentation" element={<Documentation />} />
          <Route path="/admin/sop" element={<Sop />} />
          <Route path="/admin/geo-tag/employees" element={<EmployeeAdmin />} />
          <Route path="/admin/geo-tag/report" element={<Report />} />
          <Route path="/admin/profile" element={<Profile />} />
          <Route path="/admin/id-card" element={<IdCard />} />
          <Route path="/admin/notification" element={<Notification />} />
          <Route path="/admin/mediclaimHr" element={<MediclaimHr />} />
          {/* <Route path='/admin/company-policies/policies' element={<CompanyPolicies isAdmin type='Policies' />} /> */}
          {/* <Route path='/admin/company-policies/sop' element={<CompanyPolicies isAdmin type='SOP' />} /> */}
          {/* <Route path='/admin/company-policies/escalation-matrix' element={<CompanyPolicies isAdmin type='Escalation Matrix' />} /> */}
          {/* <Route path='/admin/manage-tickets' element={<ManageTickets />} /> */}
          <Route path="*" element="" />
        </Route>
        {/* test */}
        {/* <Route path='/user/*' element={<ComingSoon />} /> */}
        <Route path="/user" element={<User />}>
          <Route path="/user/profile" element={<Profile />} />
          {/* <Route path="/user/attendance" element={<Attendance />} /> */}
          <Route
            path="/user/company-policies/policies"
            element={<CompanyPolicies type="Policies" />}
          />
          <Route
            path="/user/company-policies/sop"
            element={<CompanyPolicies type="SOP" />}
          />
          <Route
            path="/user/company-policies/escalation-matrix"
            element={<CompanyPolicies type="Escalation Matrix" />}
          />
          <Route path="/user/ticket" element={<Ticket />} />
          <Route path="/user/mediclaim" element={<Mediclaim />} />
          <Route path="/user/employee" element={<Employee />} />
          <Route path="/user/dashboard" element={<Dashboard />} />
          {/* <Route path="/user/attendence" element={<Attendence />} /> */}

          <Route path="*" element="" />
        </Route>

        {/* <Route path="/new-user/*" element={<ComingSoon />} /> */}

        <Route path="/new-user" element={<NewUser />}>
          <Route index element={<Navigate to="personal" replace />} />{" "}
          <Route path="personal" element={<PersonalDetails />} />
          <Route path="identity-detail" element={<IdentityDetail />} />
          <Route path="documents" element={<UploadDocuments />} />
          <Route path="nominees" element={<Nominee />} />
          <Route path="bank-details" element={<BankDetails />} />
          <Route path="offer-letter" element={<OfferLetter />} />
          <Route path="*" element={<Navigate to="personal" replace />} />
        </Route>

        {/* <Route path="/admin/employees-view/:id" element={<EmployeeView />} /> */}
        <Route path="/admin/employees-verification/:id" element={<NewUser />}>
          <Route index element={<Navigate to="personal" replace />} />{" "}
          <Route path="personal" element={<PersonalDetails />} />
          <Route path="identity-detail" element={<IdentityDetail />} />
          <Route path="documents" element={<UploadDocuments />} />
          <Route path="nominees" element={<Nominee />} />
          <Route path="bank-details" element={<BankDetails />} />
          <Route path="offer-letter" element={<OfferLetter />} />
          <Route path="*" element={<Navigate to="personal" replace />} />
        </Route>
        <Route path="/" element={<Navigate to="/auth" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
